$(window).on("load", dropdownmenu); //needed for the height calculations in chrome
$(window).resize(dropdownmenu);

function is_touch_device() {
    return (("ontouchstart" in window)
        || (navigator.MaxTouchPoints > 0)
        || (navigator.msMaxTouchPoints > 0));
}

function dropdownmenu() {
    // Navigation menu for the multi menu
    if ($("div.submenu").length) {
        var objNavigation = $(".product-nav nav");
        // ul container of the multi menu
        var objMenu = $("ul.submenu");
        var objDropDown = $("div.submenu");
        if ($(window).width() >= 992) {
            var objNavigationFirstMenuItem = $("nav.navigation a.top");

            // MenuItems only needed for touch
            var objMenuItems = $("ul.submenu > li > a");
            // Get the width of the header for the width of the submenu
            var intPartentWidth = objNavigation.outerWidth() - $("ul.submenu").outerWidth();
            var intParentOffset = objDropDown.parent().parent().parent().position().left;

            // Give the right width to the submenu
            objDropDown.css("width", intPartentWidth - intParentOffset - 20);

            //Function to activate the menu
            function activateSubmenu(row) {
                // row = selected li
                var $row = $(row);
                // add class that replaces the :hover and :focus css stae
                $row.addClass("maintainHover");
                // add height to the submenu
                $row.find("div.submenu").css("min-height", $row.parents(objMenu).outerHeight());
                // addClass to the body
                $("body").addClass("hover");
                dropdownmenu();
            }

            // Function to deactivate the submenu
            function deactivateSubmenu(row) {
                // row = selected li
                var $row = $(row);
                // remove class that replaces the :hover and :focus css stae
                $row.removeClass("maintainHover");
                // removeClass form the body
                $("body").removeClass("hover");
            }

            // Remove button for the submenu
            $("a.close-menu").click(function () {
                $(".maintainHover").removeClass("maintainHover");
                // only on touch
                objNavigationFirstMenuItem.parent().removeClass("show-menu");
                return false;
            });

            // If not touchdevice, hover functions
            if (!is_touch_device()) {
                objNavigationFirstMenuItem.parent().off().on("mouseenter mouseleave", function (event) {
                    if (event.type == 'mouseenter') {
                        objMenu.find("li").removeClass("maintainHover");
                        $(this).addClass('show-menu');
                    }

                    if (event.type == 'mouseleave') {
                        $(this).removeClass('show-menu');
                    }
                });

                //objNavigation.addClass("no-touch");
                // Menuaim plugin: jquery-menu-aim.js
                objMenu.menuAim({
                    activate: activateSubmenu, //Activate submenu
                    deactivate: deactivateSubmenu, // Deactivate submneu
                    exitMenu: function () { // When you hover out of the submenu remove the menu
                        return true;
                    }
                });
            }
            //Touch devices
            else {
                objNavigationFirstMenuItem.off().on("click", function () {
                    objMenu.find("li").removeClass("maintainHover");
                    $(this).parent().toggleClass("show-menu");
                    return false;
                });


                // When you click on a navigation item in the submenu
                objMenuItems.on("click touchstart", function () {
                    // Remove all the maintainhover class
                    objMenu.find("li").removeClass("maintainHover");
                    // Add maintainhover class to the parent class
                    $(this).parent().addClass("maintainHover");
                    //+ intSpanHeight)
                    $(this).parent().find("div.submenu").css("min-height", objMenu.outerHeight());
                    return false;
                });
            }
        }
        else {
            $('div.submenu').removeAttr('style');
            $(".product ul.submenu").removeAttr("style");

            if (!is_touch_device()) {
                objMenu.menuAim("destroy");
            }
        }
    }
}